"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacer = void 0;
var React = require("react");
var spacer = function (numberOfSpaces) {
    var spaces = [];
    for (var i = 0; i < numberOfSpaces; i++) {
        spaces.push(React.createElement(React.Fragment, null, "\u00A0"));
    }
    return (React.createElement("span", null, spaces));
};
exports.spacer = spacer;
//# sourceMappingURL=spacer.js.map